import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Maybe } from "@ispb/react-hooks";
import saveAs from "file-saver";
import { Fragment, useEffect, useState } from "react";
import { Anchor, Modal } from "react-bootstrap";
import { When } from "react-if";
import IconButton from "../components/IconButton.js";
import Spacer from "../components/Spacer.js";
import { useKeyPageNavigation } from "../components/useKeyPageNavigation.js";
import { DEFAULT_MODAL_PROPS, STANDARD_SPACING } from "../config.js";
import { DOWNLOAD_MULTIPLE_ICON, DOWNLOAD_SINGLE_ICON, NEXT_ICON, PREVIOUS_ICON } from "../icons.js";
import PropertiesTable from "./PropertiesTable.js";
import ThumbnailRender from "./ThumbnailRender.js";
export default function ThumbnailLightBox(props) {
    const [index, setIndex] = useState(props.index ?? 0);
    const thumbnails = [props.thumbnails].flat();
    const selected = thumbnails.at(index);
    if (selected === undefined) {
        throw new Error("Could not find thumbnail at index " + index + ".");
    }
    useEffect(() => {
        if (!props.show) {
            setIndex(props.index ?? 0);
        }
    }, [
        props.show
    ]);
    useKeyPageNavigation(index, setIndex, thumbnails.length);
    return (_jsx(When, { condition: props.show, children: _jsxs(Modal, { show: true, onHide: props.close, closeButton: true, ...DEFAULT_MODAL_PROPS, children: [_jsx(Modal.Header, { children: _jsxs(Modal.Title, { className: "flex-grow-1 d-flex", children: [_jsxs("div", { className: "me-auto", children: ["File ", index + 1, " of ", thumbnails.length] }), _jsx(When, { condition: thumbnails.length > 1, children: _jsxs("div", { className: "hstack gap-3", children: [_jsx("span", { children: _jsx(Anchor, { onClick: index > 0 ? () => setIndex(index - 1) : undefined, children: _jsx(FontAwesomeIcon, { ...PREVIOUS_ICON }) }) }), _jsx("span", { children: _jsx(Anchor, { onClick: index < thumbnails.length - 1 ? () => setIndex(index + 1) : undefined, children: _jsx(FontAwesomeIcon, { ...NEXT_ICON }) }) })] }) })] }) }), _jsxs(Modal.Body, { children: [_jsx(ThumbnailRender, { thumbnails: [selected], options: { border: false, embed: true, originalSize: true, aspectRatio: [4, 3], onClick: "nothing" } }), (() => {
                            if (selected.type === "thumbnail" && selected.file.properties !== undefined) {
                                const download = () => {
                                    saveAs(selected.file.url, selected.file.name);
                                };
                                const downloadAll = (() => {
                                    if (thumbnails.every(thumbnail => thumbnail.type === "thumbnail")) {
                                        return () => {
                                            if (thumbnails.length === 1) {
                                                return;
                                            }
                                            return () => {
                                                thumbnails.forEach(thumbnail => {
                                                    saveAs(selected.file.url, thumbnail.file.name);
                                                });
                                            };
                                        };
                                    }
                                })();
                                return (_jsxs(Fragment, { children: [_jsx(Spacer, {}), _jsx(Maybe, { value: selected.file.properties, children: value => {
                                                return (_jsxs(Fragment, { children: [_jsx(PropertiesTable, { properties: value }), _jsx(Spacer, {})] }));
                                            } }), _jsxs("div", { className: "hstack gap-" + STANDARD_SPACING, children: [_jsx(IconButton, { icon: DOWNLOAD_SINGLE_ICON, onClick: download, children: "Download" }), _jsx(Maybe, { value: downloadAll, children: downloadAll => {
                                                        return (_jsx(IconButton, { icon: DOWNLOAD_MULTIPLE_ICON, onClick: downloadAll, variant: "info", children: "Download All" }));
                                                    } })] })] }));
                            }
                            else {
                                return null;
                            }
                        })()] })] }) }));
}
